import * as React from "react";
import { SVGProps } from "react";

const EmailIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={30}
    height={30}
    viewBox="0 0 30 30"
    fill="none"
    {...props}
  >
    <path
      fill="#1A1C1F"
      d="M21.25 26.563H8.75c-4.563 0-7.188-2.625-7.188-7.188v-8.75c0-4.563 2.625-7.188 7.188-7.188h12.5c4.563 0 7.188 2.626 7.188 7.188v8.75c0 4.563-2.625 7.188-7.188 7.188ZM8.75 5.313c-3.575 0-5.313 1.737-5.313 5.312v8.75c0 3.575 1.738 5.313 5.313 5.313h12.5c3.575 0 5.313-1.738 5.313-5.313v-8.75c0-3.575-1.738-5.313-5.313-5.313H8.75Z"
    />
    <path
      fill="#1A1C1F"
      d="M15 16.087c-1.05 0-2.113-.325-2.925-.987l-3.913-3.125a.935.935 0 0 1 1.162-1.463l3.913 3.125c.95.763 2.563.763 3.513 0l3.912-3.125c.4-.325 1-.262 1.313.15.324.4.262 1-.15 1.313L17.912 15.1c-.8.662-1.863.987-2.912.987Z"
    />
  </svg>
);
export default EmailIcon;
